import * as React from "react"
import { Background, Container, ListLayout } from "@/components"
import * as styles from "./index.module.scss"

interface IProps {
  cooperationModelBg: {
    media: BackgroundImg
  }
  cooperationModelText: cooperationModel
}

const CooperationModel: React.FC<IProps> = props => {
  const { cooperationModelBg, cooperationModelText } = props
  return (
    <Background className={styles.cooperationModel} image={cooperationModelBg}>
      <Container>
        <h1>{cooperationModelText.title}</h1>
        <ListLayout listData={cooperationModelText.model}>
          {(item: BaseContent) => (
            <div className={styles.inner}>
              <h4>{item.title}</h4>
              <p>{item.describe}</p>
            </div>
          )}
        </ListLayout>
      </Container>
    </Background>
  )
}

export default CooperationModel
